/**
 * Start ohne Endlos-Ladebildschirm – fuer Lead Sheets und Cloud gleich.
 *
 * 1. Jeder Startschritt meldet sich (setBootStep). Steht „Lade …“ nach
 *    STALL_MS noch da, erscheint darunter, woran es haengt, und ein Knopf
 *    „Neu laden“. Der Schritt landet im Fehlerprotokoll (Admin → Diagnose).
 * 2. Kommt eine Seite aus dem Zwischenspeicher des Browsers zurueck
 *    (Zurueck-Taste, bfcache), wird sie neu geladen: Firebase hat seine
 *    Verbindung beim Verlassen beendet, die alte Seite waere tot.
 *
 * Es wird nie etwas geloescht oder zurueckgesetzt – nur angezeigt und neu
 * geladen.
 */
import { h } from '../ui/dom.ts';
import { logError } from './error-log.ts';

const STALL_MS = 12_000;

let step = 'Start';

export function setBootStep(name: string): void {
  step = name;
}

export function watchBoot(root: HTMLElement): void {
  window.addEventListener('pageshow', (ev) => {
    if (ev.persisted) location.reload();
  });
  window.setTimeout(() => {
    const loading = root.querySelector('.login__loading');
    if (!loading || !loading.isConnected) return;
    logError(`Start hängt bei: ${step}`, 'Start');
    loading.after(
      h(
        'div',
        { class: 'login__stall' },
        h('p', { class: 'hint', text: `Das dauert ungewöhnlich lange (${step}). Meist hilft neu laden; bei schwacher Verbindung kurz warten.` }),
        h('button', { class: 'btn btn--primary', text: 'Neu laden', attrs: { type: 'button' }, on: { click: () => location.reload() } }),
      ),
    );
  }, STALL_MS);
}
